// Host-based market detection.
//
// The SAME deployment/build serves the Uzbek-first primary market on
// taklifla.uz and an English-first international mode on ANY .com domain
// (taklifla.com and any future .com alias pointed at the service). Host is
// the ONLY signal used to flip catalog/demo/marketing surfaces to English
// (see i18n.ts detectInitial() and data.ts's demo-name override). It never
// touches published-invitation rendering — owner content always renders as
// the owner wrote it, on either host. Mirrors the backend's isIntlRequest
// (seo.go), which uses the same ".com" suffix rule.

/**
 * True when the page is being served from any international (.com) host.
 * SSR-safe: defaults to false when `window` isn't available (e.g. module
 * evaluated outside a browser) so non-browser contexts never get
 * misclassified as the international site.
 */
export function isIntlSite(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.hostname.toLowerCase().endsWith(".com");
}

/** Brand TLD for the .uz surface. (The .com surface is a separate brand —
 *  see brandName/brandHost — so this is only meaningful on taklifla.uz.) */
export function brandTld(): string {
  return isIntlSite() ? "com" : "uz";
}

/** Display brand name: "Utopian Invitations" on the international (.com) host,
 *  "taklifla.uz" on the primary market. Use for wordmarks, aria labels, and
 *  any user-facing brand string. */
export function brandName(): string {
  return isIntlSite() ? "Utopian Invitations" : "taklifla.uz";
}

/** Brand domain: "utopian-invites.com" internationally, else "taklifla.uz".
 *  Use where a hostname is shown to the user (e.g. a preview URL bar). */
export function brandHost(): string {
  return isIntlSite() ? "utopian-invites.com" : "taklifla.uz";
}
